import { Dialog, styled } from "@mui/material";

const StyledDialog = styled(Dialog)(({ theme }) => {
  return {
    "& .MuiBackdrop-root": {
      background: "#10182899",
    },
    "& .MuiDialog-paper": {
      borderRadius: theme.shape.borderRadius + 4 + "px",
    },
    "& .MuiDialogTitle-root": {
      ...theme.typography.h4,
      padding: theme.spacing(3),
      // textAlign: "center",
    },
    "& .MuiDialogContent-root": {
      padding: theme.spacing(3),
    },
    "& .MuiDialogActions-root": {
      paddingTop: theme.spacing(2),
      paddingBottom: theme.spacing(2),
      paddingLeft: theme.spacing(4),
      paddingRight: theme.spacing(4),
      gap: theme.spacing(1.5),
    },
  };
});

export default StyledDialog;
